import styled from 'styled-components';
import { DatePicker } from '@fluentui/react';
import { FieldError } from 'react-hook-form';

export const DateContainer = styled.div`
  width: 47%;
  height: 4.6rem;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const DatePickerStyle = styled(DatePicker)<{
  error?: FieldError;
}>`
  width: 100%;

  .ms-TextField-field {
    background: ${(props) => props.theme.popupInputMainBackground};
    color: ${(props) => props.theme.textMainColor};
  }

  [class*='readOnlyPlaceholder-'],
  .ms-DatePicker-event--without-label.msDatePickerDisabled {
    color: ${(props) => props.theme.textMainColor};
  }

  .ms-TextField-fieldGroup {
    border: 1.5px solid
      ${(props) =>
        props.error
          ? props.theme.popupErrorColor
          : props.theme.popupInputBorderColor};
    border-radius: 4px;
    overflow: hidden;
  }

  box-shadow: 0px 3.2px 7.2px rgba(0, 0, 0, 0.13),
    0px 0.6px 1.8px rgba(0, 0, 0, 0.11);
  border-radius: 4px;

  @media (max-width: 710px) {
    height: 40px;
    .ms-TextField-field,
    [class*='readOnlyPlaceholder-'],
    .ms-DatePicker-event--without-label.msDatePickerDisabled,
    .ms-TextField-fieldGroup {
      height: 100%;
      margin-bottom: 20px;
    }
  }
  input:disabled {
    background: ${(props) => props.theme.popupInputMainBackground};
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const HeaderLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};

  .required {
    color: red;
  }

  @media (max-width: 710px) {
    font-size: 18px;
  }
`;

export const DatePickerContainer = styled.div`
  width: 100%;
  height: 100%;
`;
